import { useEffect, useState } from "react"
import { IoAddOutline, IoCloudUploadOutline, IoPencilOutline, IoSearchOutline } from "react-icons/io5"
import { useNavigate } from "react-router-dom"
import { useDispatch } from "react-redux"
import { AppDispatch } from "../../store"

import PageLayout from "../../components/layouts/PageLayout"
import CustomNavbar from "../../components/common/CustomNavbar"
import ECSLoader from "../../components/common/EcsLoader"

import { ChatbotRule, ChatbotRuleApi } from "../../types/chatbotType"
import { fetchChatbotRules } from "../../features/chatbot/ChatBotServices"
import { editIcon } from "../../asset"

export default function ChatBot() {
    const navigate = useNavigate()
    const dispatch = useDispatch<AppDispatch>()

    const [rules, setRules] = useState<ChatbotRule[]>([])
    const [searchQuery, setSearchQuery] = useState("")
    const [loading, setLoading] = useState(false)

    const mapRule = (rule: ChatbotRuleApi): ChatbotRule => ({
        id: String(rule.id),
        keyword: rule.keyword,
        responseText: rule.responseText || "",
        responseType: rule.responseType,
        mediaId: rule.mediaId,
        createdAt: new Date(rule.createdAt).toLocaleDateString(),
    })

    const loadRules = async () => {
        setLoading(true)

        const result = await dispatch(fetchChatbotRules({ page: 0, size: 10 }))

        if (fetchChatbotRules.fulfilled.match(result)) {
            const mapped = result.payload.results.map(mapRule)
            setRules(mapped)
        }

        setLoading(false)
    }

    useEffect(() => {
        loadRules()
    }, [])

    const filtered = rules.filter((r) =>
        r.keyword.toLowerCase().includes(searchQuery.toLowerCase())
    )

    return (
        <PageLayout
            customNavbar={
                <CustomNavbar>
                    <span className="font-bold text-lg uppercase">Chatbot Rules</span>
                </CustomNavbar>
            }
        >
            <div className="rounded-4xl w-full bg-gray-100">
                <div className="flex flex-col rounded-4xl w-full p-4 bg-white min-h-screen gap-6 relative">
                    <ECSLoader show={loading} />

                    {/* Header */}
                    <div className="flex justify-between items-center">
                        <div>
                            <h2 className="text-xl font-bold">Auto Reply Rules</h2>
                            <p className="text-sm text-text-secondary">
                                Configure keyword auto replies
                            </p>
                        </div>

                        <button
                            onClick={() => navigate("/admin/chatbot/add")}
                            className="flex items-center gap-2 px-5 py-3 rounded-4xl bg-brand-blue-gradient text-white font-bold"
                        >
                            <IoAddOutline />
                            Add Rule
                        </button>
                    </div>

                    {/* Search */}
                    {/* <div className="relative">
            <IoSearchOutline className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
            <input
              type="text"
              placeholder="Search keyword..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="w-full pl-10 pr-4 py-2 border rounded-xl"
            />
          </div> */}

                    {/* List */}
                    <div className="overflow-x-auto">
                        <table className="w-full text-sm border-separate border-spacing-y-2">
                            <thead className="text-gray-600">
                                <tr>
                                    <th className="p-2 text-left font-bold">Keyword</th>
                                    <th className="p-2 text-left font-bold">Response</th>
                                    <th className="p-2 text-left font-bold">Response Type</th>
                                    <th className="p-2 text-left font-bold">Media</th>
                                    <th className="p-2 text-left font-bold">Created At</th>
                                    <th className="p-2 text-left font-bold w-20">Action</th>
                                </tr>
                            </thead>

                            <tbody>
                                {filtered.length === 0 ? (
                                    <tr>
                                        <td colSpan={6} className="text-center py-10 text-gray-400">
                                            No rules found
                                        </td>
                                    </tr>
                                ) : (
                                    filtered.map((rule) => (
                                        <tr
                                            key={rule.id}
                                            className="even:bg-gray-50 odd:bg-white hover:bg-gray-100"
                                        >
                                            {/* Keyword */}
                                            <td className="p-3">
                                                <span className="font-semibold px-2 py-1  rounded-md">
                                                    {rule.keyword}
                                                </span>
                                            </td>

                                            {/* Response */}
                                            <td className="p-3 max-w-[350px] truncate">
                                                {rule.responseText || "—"}
                                            </td>

                                            {/* Response Type */}
                                            <td className="p-3">
                                                <span className="text-xs font-semibold px-2 py-1 bg-gray-100 rounded-md">
                                                    {rule.responseType}
                                                </span>
                                            </td>

                                            {/* Media */}
                                            <td className="p-3">
                                                {rule.mediaId ? (
                                                    <span className="flex items-center gap-1 text-xs text-gray-500">
                                                        <IoCloudUploadOutline />
                                                        {rule.mediaId}
                                                    </span>
                                                ) : (
                                                    "—"
                                                )}
                                            </td>

                                            {/* Created At */}
                                            <td className="p-3 whitespace-nowrap">{rule.createdAt}</td>

                                            {/* Action */}
                                            <td className="p-3">
                                                <img
                                                    src={editIcon}
                                                    alt="Edit"
                                                    className="w-4 h-4 cursor-pointer"
                                                    onClick={() => navigate(`/admin/chatbot/edit/${rule.id}`)}
                                                />
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>

                </div>
            </div>
        </PageLayout>
    )
}